// src/components/Projects.js
import React from "react";
import { ChevronRight, ArrowRight } from "lucide-react";
import SectionTitle from "./shared/SectionTitle";
import resumeData from "../data/resumeData";
import { useModal } from "../context/ModalContext";

const Projects = () => {
	const { projects } = resumeData;
	const { openModal } = useModal();

	return (
		<section className="max-w-6xl mx-auto">
			<SectionTitle>Personal Projects</SectionTitle>
			<div className="grid md:grid-cols-2 gap-6 lg:gap-8">
				{projects.map((project, index) => (
					<div
						key={index}
						className="group flex flex-col bg-white border border-slate-200/80 shadow-card rounded-2xl p-8 transition-all duration-300 hover:shadow-lift hover:-translate-y-1"
					>
						<h3 className="text-xl md:text-2xl font-bold text-slate-900 mb-4">
							{project.name}
						</h3>
						<ul className="space-y-2.5 mb-6">
							{project.description.map((item, i) => (
								<li key={i} className="flex items-start text-slate-600">
									<ChevronRight
										className="text-brand-500 mt-1 mr-2 flex-shrink-0"
										size={16}
									/>
									<span>{item}</span>
								</li>
							))}
						</ul>
						<div className="flex flex-wrap gap-2 mb-6 mt-auto">
							{project.tags.map((tag, i) => (
								<span
									key={i}
									className="bg-slate-100 text-slate-700 ring-1 ring-slate-200/70 px-3 py-1 rounded-full text-xs font-medium"
								>
									{tag}
								</span>
							))}
						</div>

						{/* View Project Button */}
						<button
							onClick={() => openModal(project)}
							className="inline-flex items-center self-start text-brand-600 hover:text-brand-700 font-semibold"
						>
							View Details
							<ArrowRight
								size={18}
								className="ml-1.5 transition-transform duration-300 group-hover:translate-x-1"
							/>
						</button>
					</div>
				))}
			</div>
		</section>
	);
};

export default Projects;
